import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { WhyChooseUs } from './components/WhyChooseUs';
import { TechPartners } from './components/TechPartners';
import { CaseStudies } from './components/CaseStudies';
import { Testimonials } from './components/Testimonials';
import { BlogTeaser } from './components/BlogTeaser';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-black text-white font-sans selection:bg-brand-primary/30 selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <ServicesSection data-id="element-5" />
        <WhyChooseUs data-id="element-6" />
        <TechPartners data-id="element-7" />
        <CaseStudies data-id="element-8" />
        <Testimonials data-id="element-9" />
        <BlogTeaser data-id="element-10" />
        <CTASection data-id="element-11" />
      </main>

      <Footer data-id="element-12" />
    </div>;
}